"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInformationStep = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const organisms_1 = require("../../../components/organisms");
const atome_1 = require("../../../components/atome");
const Dashboard_style_1 = require("./Dashboard.style");
const UserInformationStep = (props) => {
    const { navigateTo } = props;
    return (react_1.default.createElement(organisms_1.TimelineEntry, { checked: true, title: 'Angaben' + '\n' + 'vervollständigen', subTitle: ' ', infoText: react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.75, style: [Dashboard_style_1.styles.button, Dashboard_style_1.styles.buttonInfo], onPress: () => navigateTo('CaseHistoryOverview') },
                react_1.default.createElement(atome_1.Text, { style: [Dashboard_style_1.styles.buttonText] }, "Details"))) }));
};
exports.UserInformationStep = UserInformationStep;
